// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2jyXu","legacyBtn":"MutateMid_legacyBtn__1MGYS"};